import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import Navbarp from "../Components/CommonComponents/Navbarp";
import ".././css/Otp.css";
import {
  APPLICATION_ID,
  AUTH_BASE_URL,
  BASE_URL,
  CLIENT_ID,
} from "../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import { setCoupanData } from "../features/Coupon";
import { setplans } from "../features/Plan";
import {
  logout,
  setTempToken,
  setOAuthTokens,
  setLogin,
  getLogin,
  getTempToken,
  getToken,
  getTokenReady,
} from "../features/Loginuser";
import { setlogin, setAuthorizationCode } from "../features/Loginuser";
import { Navigate, useNavigate } from "react-router-dom";
import SmallLoader from "../Components/CommonComponents/SmallLoader";
import {
  verifyOtpWithAxios,
  resendOtpWithAxios,
  apiAxiosInstance,
  initiateOAuthFlowWithAxios,
} from "../utils/AxiosAuthClient";
import { useSilentAuth } from "../hooks/useSilentAuth";

function OtpVerification() {
  const token = useSelector(getToken);
  const login = useSelector(getLogin);
  const [otp, setOtp] = useState("******");
  const [error, setError] = useState("");
  const [errorotp, setErrorOtp] = useState(false);
  const tempToken = useSelector(getTempToken);
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [response, setResponse] = useState(false);
  const dispatch = useDispatch();
  const { triggerSilentFlow } = useSilentAuth();
  const navigate = useNavigate();
  const tokenReady = useSelector(getTokenReady);
  function getotp(otp) {
    setOtp(otp);
  }
  useEffect(() => {
    const getData = setTimeout(() => {}, 1000);
    return () => clearTimeout(getData);
  }, [redirect]);

  /**
   * Handle OAuth authorization after OTP verification success
   * Initiates OAuth 2.0 PKCE flow using axios with session handling
   */
  const initiateOAuthFlow = async () => {
    try {
      // Initiate OAuth flow with axios
      await triggerSilentFlow();
      // Note: initiateOAuthFlowWithAxios redirects to authorization endpoint
      // Code below won't execute due to redirect
    } catch (error) {
      setError("Failed to initiate authorization flow. Please try again.");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (login && tokenReady) {
      navigate("/dashboard", {
        replace: true,
      });
    }
  }, [tokenReady]);

  async function verifyOtp(e) {
    e.preventDefault();
    setLoading(true);

    // Use axios for OTP verification
    verifyOtpWithAxios(otp, tempToken, APPLICATION_ID)
      .then((data) => {
        if (data.success == true) {
          localStorage.setItem("loginTime", new Date().toString()); // Store login time for session management
          // New OAuth flow - initiate PKCE authorization
          // initiateOAuthFlow();
          dispatch(setTempToken(""));
          dispatch(setLogin(true));
          localStorage.setItem("login", true);
          setLoading(false);
        } else {
          setLoading(false);
          setError(data.message);
          setErrorOtp(!data.success);
          setRedirect(data.redirect);
        }
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage =
          error.response?.data?.message ||
          "Error verifying OTP. Please try again.";
        setError(errorMessage);
      });
  }

  function resendOtp(e, otpBy) {
    e.preventDefault();
    setResending(true);

    // Use axios for resend OTP
    resendOtpWithAxios(tempToken, otpBy)
      .then((data) => {
        if (data.success == true) {
          // Session automatically extracted from Set-Cookie
          setError(data.message);
          setResending(false);
          dispatch(setTempToken(data.data.username));
        } else {
          setRedirect(data.redirect);
          setError(data.message);
          setResending(false);
        }
      })
      .catch((error) => {
        setResending(false);
        const errorMessage =
          error.response?.data?.message ||
          "Error resending OTP. Please try again.";
        setError(errorMessage);
      });
  }

  return (
    <div>
      <Navbarp />
      <div className="container-fluid mt-5">
        <div className="d-flex w-100 flex-row justify-content-center">
          <div
            className="d-flex w-100 flex-column justify-content-center"
            style={{ maxWidth: "500px", marginTop: "150px" }}
          >
            <p className="fs-3 fw-bold mb-5 text-center text-danger">
              2 Factor Authentication{" "}
            </p>
            <p className="fs-5 fw-bold mb-5 text-center">
              We have sent a 6 digit verification code to your mobile number
            </p>
            <div className="otpbox ">
              <div className="card">
                <form>
                  <p className="fs-5 fw-bold text-center">
                    Please enter the verification code here{" "}
                  </p>
                  <OtpInput
                    value={otp}
                    onChange={getotp}
                    containerStyle="marginTop--small"
                    inputStyle="inputstyle"
                    numInputs={6}
                    isInputNum={true}
                    separator={<span>-</span>}
                    errorStyle="error"
                    hasErrored={errorotp}
                  />
                  {error ? (
                    <p className="fs-5 fw-bold mt-5 text-danger">{error}</p>
                  ) : null}
                  <div className="d-flex flex-row mb-3 justify-content-center">
                    <button
                      className="btn btn-outline-success me-2 mt-5 btn-lg"
                      onClick={verifyOtp}
                      disabled={resending}
                    >
                      {loading ? (
                        <SmallLoader loadingtext={"Confirming..."} />
                      ) : (
                        "Confirm"
                      )}
                    </button>
                    <button
                      className="btn btn-outline-danger btn-lg ms-2 mt-5"
                      onClick={(e) => resendOtp(e, "text")}
                      disabled={loading}
                    >
                      {resending ? (
                        <SmallLoader loadingtext={"Messaging..."} />
                      ) : (
                        "Message OTP"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtpVerification;
